"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("../../Button/Button"));
var _constants = require("../../constants");
var _ComponentWrapper = _interopRequireDefault(require("../../helpers/ComponentWrapper"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Video = function Video(_ref) {
  var video = _ref.video,
    toggle = _ref.toggle;
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  function handleOnLoad() {
    setLoading(false);
  }
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal--close-desktop",
    style: {
      top: 12,
      right: 14
    }
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    icon: "cross",
    buttonType: _constants.BUTTON_TYPES.BARE_WHITE,
    onClick: toggle,
    buttonSize: _constants.BUTTON_SIZES.LARGE
  })), /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], {
    className: "max-width-md height-100%"
  }, loading && /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal--placeholder height-100% width-100%"
  }), /*#__PURE__*/_react["default"].createElement("iframe", {
    className: "width-100% height-100% ".concat(loading && 'is-hidden'),
    title: "title",
    src: video,
    frameBorder: "0",
    allow: "autoplay; encrypted-media",
    allowFullScreen: "true",
    webkitallowfullscreen: "true",
    mozallowfullscreen: "true",
    onLoad: handleOnLoad
  })));
};
Video.propTypes = {
  video: _propTypes["default"].string,
  toggle: _propTypes["default"].func
};
var _default = exports["default"] = Video;